<!-- HeaderView.vue -->
<template>
  <header>
    <nav class="sticky top-0 bg-primaryColor w-full z-50 shadow-md">
      <div class="max-w-screen-xl mx-auto flex flex-nowrap items-center justify-between p-4">
        <!-- Logo -->
        <RouterLink to="/" class="flex items-center space-x-3 rtl:space-x-reverse">
          <img src="../assets/images/ClemensLogo.svg" class="h-12 md:h-20" alt="Tanzakademie Clemens Logo" />
        </RouterLink>

        <!-- CTA + Burger Button -->
        <div class="flex items-center space-x-3">
          <button @click="toggleMenu"
            class="lg:hidden p-2 w-10 h-10 flex items-center justify-center text-sm text-gray-500 rounded-lg"
            :aria-expanded="isMenuOpen.toString()" aria-label="Hauptmenü öffnen">
            <svg class="w-5 h-5" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1h15M1 7h15M1 13h15" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round"
                stroke-width="2" />
            </svg>
          </button>
        </div>

        <!-- Menü -->
        <div id="mobile-menu" :class="[
          'transition-transform duration-300 ease-in-out fixed top-0 right-0 h-full w-2/3 bg-primaryColor z-40 transform lg:static lg:h-auto lg:w-auto lg:translate-x-0 lg:flex',
          isMenuOpen ? 'translate-x-0' : 'translate-x-full'
        ]">
          <!-- Close Button (nur mobil sichtbar) -->
          <button @click="toggleMenu" class="absolute top-4 right-4 text-white lg:hidden" aria-label="Menü schließen">
            <svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 6l12 12M6 18L18 6" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </button>

          <!-- Navigation -->
          <ul
            class="flex flex-col justify-center font-medium space-y-6 lg:p-0 mt-8 lg:mt-0 lg:flex-row lg:space-y-0 lg:space-x-8">
            <li v-for="(link, index) in navLinks" :key="index">
              <RouterLink :to="link.to"
                class="block py-2 px-4 text-lg rounded text-white hover:text-secondaryColor transition-colors">
                {{ link.label }}
              </RouterLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'

const isMenuOpen = ref(false)

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value
}

// Navigation automatisch schließen bei Route-Wechsel
const route = useRoute()
watch(() => route.fullPath, () => {
  isMenuOpen.value = false
})

// Click outside Menü schließen
onMounted(() => {
  const handler = (e) => {
    const menu = document.getElementById('mobile-menu')
    if (menu && !menu.contains(e.target)) {
      isMenuOpen.value = false
    }
  }
  document.addEventListener('mousedown', handler)
  onUnmounted(() => {
    document.removeEventListener('mousedown', handler)
  })
})

const navLinks = [
  { to: '/stundenplan', label: 'Stundenplan' },
  { to: '/preise', label: 'Preise' },
  { to: '/info', label: 'Über mich' },
  { to: '/bilder', label: 'Bilder' },
  { to: '/aktuelles', label: 'Aktuelles' },
  { to: '/kurse', label: 'Kurse' },
  { to: '/probetraining', label: 'Probetraining' },
]
</script>
